import { render, staticRenderFns } from "./HistoricalChangesList.vue?vue&type=template&id=0489e47c&scoped=true&"
import script from "./HistoricalChangesList.vue?vue&type=script&lang=ts&"
export * from "./HistoricalChangesList.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricalChangesList.vue?vue&type=style&index=0&id=0489e47c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489e47c",
  null
  
)

export default component.exports